import { createFileRoute, useParams } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { MarkSubmissionView } from '@/views/homeworks/mark-submission-view.tsx';

// 单次提交的教师批改页（量规网格或普通分数+反馈）。
export const Route = createFileRoute('/_learner/homeworks_/$id/submissions/$sid')({
  component: MarkSubmissionPage,
});

function MarkSubmissionPage() {
  const { id, sid } = useParams({ from: '/_learner/homeworks_/$id/submissions/$sid' });
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <MarkSubmissionView id={id} sid={sid} user={user} />;
}
